import type {MuseRosterEntry} from '@product/ovid/routes/mine.muses'

/** The line of a muse being made, as the bar's mono type sets it: her name, the verb, the percent when there is one. */
export function trainingLine(muse: Pick<MuseRosterEntry, 'name' | 'percent'>): string {
    return `${muse.name} · being made${muse.percent !== undefined ? ` · ${muse.percent}%` : ''}`
}
